// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.75 12.63 C3.53 12.85 3.18 12.85 2.97 12.63 C2.75 12.42 2.75 12.07 2.97 11.85 C3.18 11.64 3.53 11.64 3.75 11.85 C3.96 12.07 3.96 12.42 3.75 12.63 Z',
  'M3.75 11.85 L10.71 4.89',
  'M9.96 4.14 C9.88 4.05 9.92 3.91 10.04 3.89 L11.8 3.59 C11.93 3.57 12.03 3.67 12.01 3.8 L11.71 5.56 C11.69 5.68 11.55 5.72 11.46 5.64 Z',
  'M5.27 10.33 L4.28 7.36 C4.1 6.83 4.26 6.25 4.65 5.86 L6.22 4.29',
  'M7 4.29 C6.78 4.5 6.44 4.5 6.22 4.29 C6.01 4.07 6.01 3.72 6.22 3.51 C6.44 3.3 6.78 3.3 7 3.51 C7.21 3.72 7.21 4.07 7 4.29 Z',
  'M6.75 8.85 L9.44 9.98 C9.93 10.19 10.5 10.05 10.89 9.66 L11.52 9.03',
  'M11.88 7.75 C11.94 7.69 12.03 7.69 12.09 7.75 L12.8 8.46 C12.86 8.52 12.86 8.61 12.8 8.67 L12.09 9.38 C12.03 9.44 11.94 9.44 11.88 9.38 L11.17 8.67 C11.11 8.61 11.11 8.52 11.17 8.46 Z',
];
